export default __webpack_public_path__ + "static/media/mom-son.077b002a.jpg";